import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, inject } from '@angular/core';
import { isIgnorableClientRuntimeError } from './lib/is-ignorable-client-runtime-error';
import { LazyLoadedSentryService } from './services/lazy-loaded-sentry-service';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  private errorWrapper = inject<{ error: Error }>('ERROR_WRAPPER' as never, { optional: true });
  private lazyLoadedSentryService = inject(LazyLoadedSentryService);

  handleError(error: Error) {
    if (!error) return;
    if (isIgnorableClientRuntimeError(error)) {
      console.error(error);
      return;
    }
    if (typeof error === 'object') {
      if ('picflow-handled' in error) return;
      if ('clerkError' in error) return;
      error['picflow-handled'] = true;
    }
    if (error instanceof HttpErrorResponse) {
      console.error('HttpErrorResponse', error);
      error = new Error(error.message, { cause: error });
    }

    console.error(error);
    // eslint-disable-next-line no-debugger
    debugger;

    if (this.errorWrapper) {
      this.errorWrapper.error = error;
    } else {
      this.lazyLoadedSentryService.load().then(sentryService => sentryService.captureException(error));
    }
  }
}
